/**
 * Converts an ID to a valid HTML ID.
 */
export const idToHtmlId = (prefix: string, id: string) => `${prefix}-${id?.replace(/\W/g, '-')}`;

/**
 * Scrolls to an element.
 */
export const scrollToElement = (element?: Element | null, offset = 80) => {
  if (!element) return;

  const elementPosition = element.getBoundingClientRect().top || 0;
  const offsetPosition = elementPosition + window.scrollY - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}

export const __DEV__ = !!process.env.REACT_APP_DEV;

export const MARKETPLACE_HOST = process.env.REACT_APP_MARKETPLACE_URL || '';

export const CURRENT_YEAR = new Date().getFullYear();

export * from './geo/dms';
export * from './geo/haversine';
